import './styles/InternalSupportBanner.scss';

import { useClassHelper } from '@whistler-ui/k2/hooks';
import { useTranslation } from 'react-i18next';

import { useIsInternalSupport } from '../../hooks';
import { useGetAllEnvironments } from '../../hooks/queries/useEntitlements';
import { useAuthStore } from '../../store';

const componentName = 'c-InternalSupportBanner';

export const InternalSupportBanner = () => {
  const c = useClassHelper(componentName);
  const { t } = useTranslation();

  const { isInternalSupport } = useIsInternalSupport();
  const { data: environments } = useGetAllEnvironments(isInternalSupport);

  const {
    authValues: {
      organisationState: { organisation },
    },
  } = useAuthStore();

  if (!isInternalSupport) {
    return null;
  }

  const maintenanceEnvironments = (environments ?? [])
    .filter(environment => environment.maintenance_mode === true)
    .map(environment => environment.type);

  return (
    <div className={componentName}>
      <p className={c('__text')}>
        {t('internal_support_banner', {
          context: organisation?.support_sla,
          company: organisation?.operator_name,
        })}
        {maintenanceEnvironments.length > 0 && (
          <span className={c('__maintenance')}>
            {' '}
            {t('internal_support_banner_maintenance', {
              environments: maintenanceEnvironments.join(', '),
            })}
          </span>
        )}
      </p>
    </div>
  );
};
